import Roles from '@security/roles';
const roles = Roles.values;

class Permissions {
  static get values() {
    return {
      iamEdit: {
        id: 'iamEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['user'],
      },
      iamCreate: {
        id: 'iamCreate',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager
        ],
      },
      iamImport: {
        id: 'iamImport',
        allowedRoles: [
          roles.admin,
        ],
      },
      iamRead: {
        id: 'iamRead',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      iamUserAutocomplete: {
        id: 'iamUserAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
          roles.academyViewer,
          roles.playerEditor,
          roles.playerViewer,
          roles.coachEditor,
          roles.coachViewer,
          roles.newsEditor,
          roles.newsViewer,
        ],
      },
      auditLogRead: {
        id: 'auditLogRead',
        allowedRoles: [
          roles.admin,
          roles.auditLogViewer,
        ],
      },
      settingsEdit: {
        id: 'settingsEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },

      academyImport: {
        id: 'academyImport',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
        ],
      },
      academyCreate: {
        id: 'academyCreate',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
        ],
        allowedStorageFolders: ['academy'],
      },
      academyEdit: {
        id: 'academyEdit',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
        ],
        allowedStorageFolders: ['academy'],
      },
      academyDestroy: {
        id: 'academyDestroy',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
        ],
        allowedStorageFolders: ['academy'],
      },
      academyRead: {
        id: 'academyRead',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
          roles.academyViewer,
        ],
      },
      academyAutocomplete: {
        id: 'academyAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.academyEditor,
          roles.academyViewer,

        ],
      },

      playerImport: {
        id: 'playerImport',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.playerEditor,
        ],
      },
      playerCreate: {
        id: 'playerCreate',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.playerEditor,
        ],
        allowedStorageFolders: ['player'],
      },
      playerEdit: {
        id: 'playerEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.playerEditor,
        ],
        allowedStorageFolders: ['player'],
      },
      playerDestroy: {
        id: 'playerDestroy',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.playerEditor,
        ],
        allowedStorageFolders: ['player'],
      },
      playerRead: {
        id: 'playerRead',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.playerEditor,
          roles.playerViewer,
        ],
      },
      playerAutocomplete: {
        id: 'playerAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.playerEditor,
          roles.playerViewer,
          roles.parentEditor,
          roles.parentViewer,
          roles.sheetEventEditor,
          roles.sheetEventViewer,
        ],
      },

      propertySettingImport: {
        id: 'propertySettingImport',
        allowedRoles: [
          roles.admin,
          roles.propertySettingEditor,
        ],
      },
      propertySettingCreate: {
        id: 'propertySettingCreate',
        allowedRoles: [
          roles.admin,
          roles.propertySettingEditor,
        ],
        allowedStorageFolders: ['propertySetting'],
      },
      propertySettingEdit: {
        id: 'propertySettingEdit',
        allowedRoles: [
          roles.admin,
          roles.propertySettingEditor,
        ],
        allowedStorageFolders: ['propertySetting'],
      },
      propertySettingDestroy: {
        id: 'propertySettingDestroy',
        allowedRoles: [
          roles.admin,
          roles.propertySettingEditor,
        ],
        allowedStorageFolders: ['propertySetting'],
      },
      propertySettingRead: {
        id: 'propertySettingRead',
        allowedRoles: [
          roles.admin,
          roles.propertySettingEditor,
          roles.propertySettingViewer,
        ],
      },
      propertySettingAutocomplete: {
        id: 'propertySettingAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.propertySettingEditor,
          roles.propertySettingViewer,

        ],
      },

      coachImport: {
        id: 'coachImport',
        allowedRoles: [
          roles.admin,
          roles.coachEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      coachCreate: {
        id: 'coachCreate',
        allowedRoles: [
          roles.admin,
          roles.coachEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['coach'],
      },
      coachEdit: {
        id: 'coachEdit',
        allowedRoles: [
          roles.admin,
          roles.coachEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['coach'],
      },
      coachDestroy: {
        id: 'coachDestroy',
        allowedRoles: [
          roles.admin,
          roles.coachEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['coach'],
      },
      coachRead: {
        id: 'coachRead',
        allowedRoles: [
          roles.admin,
          roles.coachEditor,
          roles.coachViewer,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      coachAutocomplete: {
        id: 'coachAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.coachEditor,
          roles.coachViewer,
          roles.propertyManager,
          roles.subpropertyManager,

        ],
      },

      parentImport: {
        id: 'parentImport',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.parentEditor,
        ],
      },
      parentCreate: {
        id: 'parentCreate',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.parentEditor,
        ],
        allowedStorageFolders: ['parent'],
      },
      parentEdit: {
        id: 'parentEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.parentEditor,
        ],
        allowedStorageFolders: ['parent'],
      },
      parentDestroy: {
        id: 'parentDestroy',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.parentEditor,
        ],
        allowedStorageFolders: ['parent'],
      },
      parentRead: {
        id: 'parentRead',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.parentEditor,
          roles.parentViewer,
        ],
      },
      parentAutocomplete: {
        id: 'parentAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.parentEditor,
          roles.parentViewer,

        ],
      },

      newsImport: {
        id: 'newsImport',
        allowedRoles: [
          roles.admin,
          roles.newsEditor,
        ],
      },
      newsCreate: {
        id: 'newsCreate',
        allowedRoles: [
          roles.admin,
          roles.newsEditor,
        ],
        allowedStorageFolders: ['news'],
      },
      newsEdit: {
        id: 'newsEdit',
        allowedRoles: [
          roles.admin,
          roles.newsEditor,
        ],
        allowedStorageFolders: ['news'],
      },
      newsDestroy: {
        id: 'newsDestroy',
        allowedRoles: [
          roles.admin,
          roles.newsEditor,
        ],
        allowedStorageFolders: ['news'],
      },
      newsRead: {
        id: 'newsRead',
        allowedRoles: [
          roles.admin,
          roles.newsEditor,
          roles.newsViewer,
        ],
      },
      newsAutocomplete: {
        id: 'newsAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.newsEditor,
          roles.newsViewer,

        ],
      },

      trainingImport: {
        id: 'trainingImport',
        allowedRoles: [
          roles.admin,
          roles.trainingEditor,
        ],
      },
      trainingCreate: {
        id: 'trainingCreate',
        allowedRoles: [
          roles.admin,
          roles.trainingEditor,
        ],
        allowedStorageFolders: ['training'],
      },
      trainingEdit: {
        id: 'trainingEdit',
        allowedRoles: [
          roles.admin,
          roles.trainingEditor,
        ],
        allowedStorageFolders: ['training'],
      },
      trainingDestroy: {
        id: 'trainingDestroy',
        allowedRoles: [
          roles.admin,
          roles.trainingEditor,
        ],
        allowedStorageFolders: ['training'],
      },
      trainingRead: {
        id: 'trainingRead',
        allowedRoles: [
          roles.admin,
          roles.trainingEditor,
          roles.trainingViewer,
        ],
      },
      trainingAutocomplete: {
        id: 'trainingAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.trainingEditor,
          roles.trainingViewer,

        ],
      },

      gameImport: {
        id: 'gameImport',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      gameCreate: {
        id: 'gameCreate',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['game'],
      },
      gameEdit: {
        id: 'gameEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['game'],
      },
      gameDestroy: {
        id: 'gameDestroy',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['game'],
      },
      gameRead: {
        id: 'gameRead',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      gameAutocomplete: {
        id: 'gameAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },

      eventImport: {
        id: 'eventImport',
        allowedRoles: [
          roles.admin,
          roles.eventEditor,
        ],
      },
      eventCreate: {
        id: 'eventCreate',
        allowedRoles: [
          roles.admin,
          roles.eventEditor,
        ],
        allowedStorageFolders: ['event'],
      },
      eventEdit: {
        id: 'eventEdit',
        allowedRoles: [
          roles.admin,
          roles.eventEditor,
        ],
        allowedStorageFolders: ['event'],
      },
      eventDestroy: {
        id: 'eventDestroy',
        allowedRoles: [
          roles.admin,
          roles.eventEditor,
        ],
        allowedStorageFolders: ['event'],
      },
      eventRead: {
        id: 'eventRead',
        allowedRoles: [
          roles.admin,
          roles.eventEditor,
          roles.eventViewer,
        ],
      },
      eventAutocomplete: {
        id: 'eventAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.eventEditor,
          roles.eventViewer,

        ],
      },

      teamImport: {
        id: 'teamImport',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.teamEditor,
        ],
      },
      teamCreate: {
        id: 'teamCreate',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.teamEditor,
        ],
        allowedStorageFolders: ['team'],
      },
      teamEdit: {
        id: 'teamEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.teamEditor,
        ],
        allowedStorageFolders: ['team'],
      },
      teamDestroy: {
        id: 'teamDestroy',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.teamEditor,
        ],
        allowedStorageFolders: ['team'],
      },
      teamRead: {
        id: 'teamRead',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.teamEditor,
          roles.teamViewer,
        ],
      },
      teamAutocomplete: {
        id: 'teamAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.teamEditor,
          roles.teamViewer,
          roles.playerEditor,
          roles.playerViewer,
          roles.coachEditor,
          roles.coachViewer,
          roles.trainingEditor,
          roles.trainingViewer,
          roles.gameEditor,
          roles.gameViewer,
          roles.fanEditor,
          roles.fanViewer,
          roles.sheetEventEditor,
          roles.sheetEventViewer,
          roles.clubEditor,
          roles.clubViewer,
        ],
      },

      positionImport: {
        id: 'positionImport',
        allowedRoles: [
          roles.admin,
          roles.positionEditor,
        ],
      },
      positionCreate: {
        id: 'positionCreate',
        allowedRoles: [
          roles.admin,
          roles.positionEditor,
        ],
        allowedStorageFolders: ['position'],
      },
      positionEdit: {
        id: 'positionEdit',
        allowedRoles: [
          roles.admin,
          roles.positionEditor,
        ],
        allowedStorageFolders: ['position'],
      },
      positionDestroy: {
        id: 'positionDestroy',
        allowedRoles: [
          roles.admin,
          roles.positionEditor,
        ],
        allowedStorageFolders: ['position'],
      },
      positionRead: {
        id: 'positionRead',
        allowedRoles: [
          roles.admin,
          roles.positionEditor,
          roles.positionViewer,
        ],
      },
      positionAutocomplete: {
        id: 'positionAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.positionEditor,
          roles.positionViewer,

        ],
      },

      fanImport: {
        id: 'fanImport',
        allowedRoles: [
          roles.admin,
          roles.fanEditor,
        ],
      },
      fanCreate: {
        id: 'fanCreate',
        allowedRoles: [
          roles.admin,
          roles.fanEditor,
        ],
        allowedStorageFolders: ['fan'],
      },
      fanEdit: {
        id: 'fanEdit',
        allowedRoles: [
          roles.admin,
          roles.fanEditor,
        ],
        allowedStorageFolders: ['fan'],
      },
      fanDestroy: {
        id: 'fanDestroy',
        allowedRoles: [
          roles.admin,
          roles.fanEditor,
        ],
        allowedStorageFolders: ['fan'],
      },
      fanRead: {
        id: 'fanRead',
        allowedRoles: [
          // roles.admin,
          roles.fanEditor,
          roles.fanViewer,
        ],
      },
      fanAutocomplete: {
        id: 'fanAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.fanEditor,
          roles.fanViewer,

        ],
      },
      sheetEventImport: {
        id: 'sheetEventImport',
        allowedRoles: [
          roles.admin,
          roles.sheetEventEditor,
        ],
      },
      sheetEventCreate: {
        id: 'sheetEventCreate',
        allowedRoles: [
          roles.admin,
          roles.sheetEventEditor,
        ],
        allowedStorageFolders: ['sheetEvent'],
      },
      sheetEventEdit: {
        id: 'sheetEventEdit',
        allowedRoles: [
          roles.admin,
          roles.sheetEventEditor,
        ],
        allowedStorageFolders: ['sheetEvent'],
      },
      sheetEventDestroy: {
        id: 'sheetEventDestroy',
        allowedRoles: [
          roles.admin,
          roles.sheetEventEditor,
        ],
        allowedStorageFolders: ['sheetEvent'],
      },
      sheetEventRead: {
        id: 'sheetEventRead',
        allowedRoles: [
          roles.admin,
          roles.sheetEventEditor,
          roles.sheetEventViewer,
        ],
      },
      sheetEventAutocomplete: {
        id: 'sheetEventAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.sheetEventEditor,
          roles.sheetEventViewer,

        ],
      },
      siteImport: {
        id: 'siteImport',
        allowedRoles: [
          roles.admin,
          roles.siteEditor,
        ],
      },
      siteCreate: {
        id: 'siteCreate',
        allowedRoles: [
          roles.admin,
          roles.siteEditor,
        ],
        allowedStorageFolders: ['site'],
      },
      siteEdit: {
        id: 'siteEdit',
        allowedRoles: [
          roles.admin,
          roles.siteEditor,
        ],
        allowedStorageFolders: ['site'],
      },
      siteDestroy: {
        id: 'siteDestroy',
        allowedRoles: [
          roles.admin,
          roles.siteEditor,
        ],
        allowedStorageFolders: ['site'],
      },
      siteRead: {
        id: 'siteRead',
        allowedRoles: [
          roles.admin,
          roles.siteEditor,
          roles.siteViewer,
        ],
      },
      siteAutocomplete: {
        id: 'siteAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.siteEditor,
          roles.siteViewer,
        ],
      },
      clubImport: {
        id: 'clubImport',
        allowedRoles: [
          roles.admin,
          roles.clubEditor,
        ],
      },
      clubCreate: {
        id: 'clubCreate',
        allowedRoles: [
          roles.admin,
          roles.clubEditor,
        ],
        allowedStorageFolders: ['club'],
      },
      clubEdit: {
        id: 'clubEdit',
        allowedRoles: [
          roles.admin,
          roles.clubEditor,
        ],
        allowedStorageFolders: ['club'],
      },
      clubDestroy: {
        id: 'clubDestroy',
        allowedRoles: [
          roles.admin,
          roles.clubEditor,
        ],
        allowedStorageFolders: ['club'],
      },
      clubRead: {
        id: 'clubRead',
        allowedRoles: [
          roles.admin,
          roles.clubEditor,
          roles.clubViewer,
        ],
      },
      clubAutocomplete: {
        id: 'clubAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.clubEditor,
          roles.clubViewer,

        ],
      },
      serviceImport: {
        id: 'serviceImport',
        allowedRoles: [
          roles.admin,
          roles.serviceEditor,
        ],
      },
      serviceCreate: {
        id: 'serviceCreate',
        allowedRoles: [
          roles.admin,
          roles.serviceEditor,
        ],
        allowedStorageFolders: ['service'],
      },
      serviceEdit: {
        id: 'serviceEdit',
        allowedRoles: [
          roles.admin,
          roles.serviceEditor,
        ],
        allowedStorageFolders: ['service'],
      },
      serviceDestroy: {
        id: 'serviceDestroy',
        allowedRoles: [
          roles.admin,
          roles.serviceEditor,
        ],
        allowedStorageFolders: ['service'],
      },
      serviceRead: {
        id: 'serviceRead',
        allowedRoles: [
          roles.admin,
          roles.serviceEditor,
          roles.serviceViewer,
        ],
      },
      serviceAutocomplete: {
        id: 'serviceAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.serviceEditor,
          roles.serviceViewer,

        ],
      },

      propertyImport: {
        id: 'propertyImport',
        allowedRoles: [
          roles.admin,
          roles.propertyEditor,
        ],
      },
      propertyCreate: {
        id: 'propertyCreate',
        allowedRoles: [
          roles.admin,
          roles.propertyEditor,
        ],
        allowedStorageFolders: ['property'],
      },
      propertyEdit: {
        id: 'propertyEdit',
        allowedRoles: [
          roles.admin,
          roles.propertyEditor,
        ],
        allowedStorageFolders: ['property'],
      },
      propertyDestroy: {
        id: 'propertyDestroy',
        allowedRoles: [
          roles.admin,
          roles.propertyEditor,
        ],
        allowedStorageFolders: ['property'],
      },
      propertyRead: {
        id: 'propertyRead',
        allowedRoles: [
          roles.admin,
          roles.propertyEditor,
          roles.propertyViewer,
          roles.propertyManager,
        ],
      },
      propertyReadList: {
        id: 'propertyReadList',
        allowedRoles: [
          roles.admin,
        ],
      },
      propertyReadOne: {
        id: 'propertyReadOne',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
        ],
      },
      propertyAutocomplete: {
        id: 'propertyAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.propertyEditor,
          roles.propertyViewer,
        ],
      },

      subpropertyImport: {
        id: 'subpropertyImport',
        allowedRoles: [
          roles.admin,
          roles.subpropertyEditor,
          roles.subpropertyManager,
          roles.propertyManager,
        ],
      },
      subpropertyCreate: {
        id: 'subpropertyCreate',
        allowedRoles: [
          roles.admin,
          roles.subpropertyEditor,
          roles.subpropertyManager,
          roles.propertyManager,
        ],
        allowedStorageFolders: ['subproperty'],
      },
      subpropertyEdit: {
        id: 'subpropertyEdit',
        allowedRoles: [
          roles.admin,
          roles.subpropertyEditor,
          roles.propertyManager,
        ],
        allowedStorageFolders: ['subproperty'],
      },
      subpropertyDestroy: {
        id: 'subpropertyDestroy',
        allowedRoles: [
          roles.admin,
          roles.subpropertyEditor,
          roles.propertyManager,
        ],
        allowedStorageFolders: ['subproperty'],
      },
      subpropertyRead: {
        id: 'subpropertyRead',
        allowedRoles: [
          roles.admin,
          roles.subpropertyEditor,
          roles.subpropertyViewer,
          roles.subpropertyManager,
          roles.propertyManager,
        ],
      },
      subpropertyAutocomplete: {
        id: 'subpropertyAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.subpropertyEditor,
          roles.subpropertyViewer,
          roles.programManager
        ],
      },


      programImport: {
        id: 'programImport',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
        ],
      },
      programCreate: {
        id: 'programCreate',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['program'],
      },
      programEdit: {
        id: 'programEdit',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['program'],
      },
      programDestroy: {
        id: 'programDestroy',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['program'],
      },
      programRead: {
        id: 'programRead',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },
      programAutocomplete: {
        id: 'programAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },

      subprogramImport: {
        id: 'programImport',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
        ],
      },
      subprogramCreate: {
        id: 'programCreate',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.subprogramEditor,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
        allowedStorageFolders: ['program'],
      },
      subprogramEdit: {
        id: 'programEdit',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
        allowedStorageFolders: ['program'],
      },
      subprogramDestroy: {
        id: 'programDestroy',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
        allowedStorageFolders: ['program'],
      },
      subprogramRead: {
        id: 'programRead',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },
      subprogramAutocomplete: {
        id: 'programAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.programEditor,
          roles.subpropertyManager,
          roles.programViewer,
          roles.propertyManager,
        ],
      },

      newsletterImport: {
        id: 'newsletterImport',
        allowedRoles: [
          roles.admin,
          roles.newsletterEditor,
          roles.programManager,
        ],
      },
      newsletterCreate: {
        id: 'newsletterCreate',
        allowedRoles: [
          roles.admin,
          roles.newsletterEditor,
          roles.programManager,
        ],
        allowedStorageFolders: ['newsletter'],
      },
      newsletterEdit: {
        id: 'newsletterEdit',
        allowedRoles: [
          roles.admin,
          roles.newsletterEditor,
        ],
        allowedStorageFolders: ['newsletter'],
      },
      newsletterDestroy: {
        id: 'newsletterDestroy',
        allowedRoles: [
          roles.admin,
          roles.newsletterEditor,
        ],
        allowedStorageFolders: ['newsletter'],
      },
      newsletterRead: {
        id: 'newsletterRead',
        allowedRoles: [
          roles.admin,
          roles.newsletterEditor,
          roles.newsletterViewer,
        ],
      },
      newsletterAutocomplete: {
        id: 'newsletterAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.newsletterEditor,
          roles.newsletterViewer,
          roles.commentEditor,
          roles.commentViewer,
        ],
      },

      commentImport: {
        id: 'commentImport',
        allowedRoles: [
          roles.admin,
          roles.commentEditor,
        ],
      },
      commentCreate: {
        id: 'commentCreate',
        allowedRoles: [
          roles.admin,
          roles.commentEditor,
        ],
        allowedStorageFolders: ['comment'],
      },
      commentEdit: {
        id: 'commentEdit',
        allowedRoles: [
          roles.admin,
          roles.commentEditor,
        ],
        allowedStorageFolders: ['comment'],
      },
      commentDestroy: {
        id: 'commentDestroy',
        allowedRoles: [
          roles.admin,
          roles.commentEditor,
        ],
        allowedStorageFolders: ['comment'],
      },
      commentRead: {
        id: 'commentRead',
        allowedRoles: [
          roles.admin,
          roles.commentEditor,
          roles.commentViewer,
        ],
      },
      commentAutocomplete: {
        id: 'commentAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.commentEditor,
          roles.commentViewer,

        ],
      },

      categoryImport: {
        id: 'categoryImport',
        allowedRoles: [
          roles.admin,
          roles.categoryEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      categoryCreate: {
        id: 'categoryCreate',
        allowedRoles: [
          roles.admin,
          roles.categoryEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['category'],
      },
      categoryEdit: {
        id: 'categoryEdit',
        allowedRoles: [
          roles.admin,
          roles.categoryEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['category'],
      },
      categoryDestroy: {
        id: 'categoryDestroy',
        allowedRoles: [
          roles.admin,
          roles.categoryEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['category'],
      },
      categoryRead: {
        id: 'categoryRead',
        allowedRoles: [
          roles.admin,
          roles.categoryEditor,
          roles.categoryViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },
      categoryAutocomplete: {
        id: 'categoryAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.categoryEditor,
          roles.categoryViewer,
          roles.teamEditor,
          roles.teamViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },

      seasonImport: {
        id: 'seasonImport',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.seasonEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      seasonCreate: {
        id: 'seasonCreate',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.seasonEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['season'],
      },
      seasonEdit: {
        id: 'seasonEdit',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.seasonEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['season'],
      },
      seasonDestroy: {
        id: 'seasonDestroy',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.seasonEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['season'],
      },
      seasonRead: {
        id: 'seasonRead',
        allowedRoles: [
          roles.admin,
          roles.seasonEditor,
          roles.seasonViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },
      seasonAutocomplete: {
        id: 'seasonAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.seasonEditor,
          roles.seasonViewer,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },

      locationImport: {
        id: 'locationImport',
        allowedRoles: [
          roles.admin,
          roles.locationEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      locationCreate: {
        id: 'locationCreate',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.locationEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['location'],
      },
      locationEdit: {
        id: 'locationEdit',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.locationEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['location'],
      },
      locationDestroy: {
        id: 'locationDestroy',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.locationEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['location'],
      },
      locationRead: {
        id: 'locationRead',
        allowedRoles: [
          roles.admin,
          roles.locationEditor,
          roles.locationViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },
      locationAutocomplete: {
        id: 'locationAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.locationEditor,
          roles.locationViewer,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
          roles.programManager,
        ],
      },

      priceImport: {
        id: 'priceImport',
        allowedRoles: [
          roles.admin,
          roles.priceEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      priceCreate: {
        id: 'priceCreate',
        allowedRoles: [
          roles.admin,
          roles.priceEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['price'],
      },
      priceEdit: {
        id: 'priceEdit',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.priceEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['price'],
      },
      priceDestroy: {
        id: 'priceDestroy',
        allowedRoles: [
          roles.admin,
          roles.priceEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['price'],
      },
      priceRead: {
        id: 'priceRead',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.viewer,
          roles.entityEditor,
          roles.priceEditor,
          roles.priceViewer,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      priceAutocomplete: {
        id: 'priceAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.priceEditor,
          roles.priceViewer,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },

      paymentOptionImport: {
        id: 'paymentOptionImport',
        allowedRoles: [
          roles.admin,
          roles.paymentOptionEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      paymentOptionCreate: {
        id: 'paymentOptionCreate',
        allowedRoles: [
          roles.admin,
          roles.paymentOptionEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['paymentOption'],
      },
      paymentOptionEdit: {
        id: 'paymentOptionEdit',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.entityEditor,
          roles.paymentOptionEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['paymentOption'],
      },
      paymentOptionDestroy: {
        id: 'paymentOptionDestroy',
        allowedRoles: [
          roles.admin,
          roles.paymentOptionEditor,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
        allowedStorageFolders: ['paymentOption'],
      },
      paymentOptionRead: {
        id: 'paymentOptionRead',
        allowedRoles: [
          roles.admin,
          roles.editor,
          roles.viewer,
          roles.entityEditor,
          roles.paymentOptionEditor,
          roles.paymentOptionViewer,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },
      paymentOptionAutocomplete: {
        id: 'paymentOptionAutocomplete',
        allowedRoles: [
          roles.admin,
          roles.paymentOptionEditor,
          roles.paymentOptionViewer,
          roles.programEditor,
          roles.programViewer,
          roles.propertyManager,
          roles.subpropertyManager,
        ],
      },

      inscriptionRead: {
        id: 'inscriptionRead',
        allowedRoles: [
          roles.admin,
          roles.propertyManager,
          roles.subpropertyManager
        ]
      }

    };
  }

  static get asArray() {
    return Object.keys(this.values).map((value) => {
      return this.values[value];
    });
  }
}

export default Permissions;
